import React, { useEffect, useState } from 'react';
import { blogService } from '../services';
import { resolveMediaUrl } from '../services/api';
import PageBreadcrumb from '../components/PageBreadcrumb';

const News = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeBlog, setActiveBlog] = useState(null);

    useEffect(() => {
        fetchBlogs();
    }, []);

    const fetchBlogs = async () => {
        try {
            const response = await blogService.getAll();
            setBlogs(response.data.data || []);
        } catch (error) {
            console.error('Error fetching blogs:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bg-gray-50">
            <PageBreadcrumb
                title="News & Blog"
                description="Latest updates from YAP"
                items={[{ label: 'News' }]}
            />

            <section className="py-16">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    {loading ? (
                        <div className="text-center py-12">
                            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600"></div>
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            {blogs.map((blog) => (
                                <article key={blog.id} className="soft-enter hover-lift bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition">
                                    {blog.featured_image && (
                                        <img src={resolveMediaUrl(blog.featured_image)} alt={blog.title} className="w-full h-48 object-cover" />
                                    )}
                                    <div className="p-6">
                                        <div className="flex items-center justify-between mb-3">
                                            <span className="text-sm text-gray-500">
                                                {blog.published_at ? new Date(blog.published_at).toLocaleDateString() : 'Draft'}
                                            </span>
                                            <span className="text-sm font-semibold text-emerald-600">
                                                {blog.author?.name || 'YAP Team'}
                                            </span>
                                        </div>
                                        <h3 className="text-xl font-bold text-gray-800 mb-3">{blog.title}</h3>
                                        <p className="text-gray-600 line-clamp-2 mb-4">{blog.content}</p>
                                        <button
                                            onClick={() => setActiveBlog(blog)}
                                            className="text-emerald-600 hover:text-emerald-700 font-semibold"
                                        >
                                            Read More
                                        </button>
                                    </div>
                                </article>
                            ))}
                        </div>
                    )}
                </div>
            </section>

            {activeBlog && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4" onClick={() => setActiveBlog(null)}>
                    <div className="max-h-[90vh] max-w-3xl overflow-y-auto rounded-lg bg-white" onClick={(e) => e.stopPropagation()}>
                        {activeBlog.featured_image && (
                            <img src={resolveMediaUrl(activeBlog.featured_image)} alt={activeBlog.title} className="h-72 w-full object-cover" />
                        )}
                        <div className="p-6">
                            <h2 className="mb-2 text-2xl font-bold text-gray-800">{activeBlog.title}</h2>
                            <p className="mb-4 text-sm text-gray-500">
                                {activeBlog.published_at ? new Date(activeBlog.published_at).toLocaleDateString() : 'Draft'}
                            </p>
                            <p className="whitespace-pre-line text-gray-700">{activeBlog.content}</p>
                            <button onClick={() => setActiveBlog(null)} className="mt-6 rounded bg-gray-200 px-4 py-2 text-sm text-gray-700 hover:bg-gray-300">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default News;
